import type { LandId } from './landPositions';
import solSkyImg from './sol_sky.png';
import muSkyImg from './mu_sky.png';
import serjLandImg from './serj_land.png';
import monaSeaImg from './mona_sea.png';
import duckSeaImg from './duck_sea.png';
import yettiLandImg from './yetti_land.png';
import rozaLandImg from './roza_land.png';
import svamiLandImg from './svami_land.png';
import vulcanoLandImg from './vulcano_land.png';
import factorLandImg from './factor_land.png';
import drakochiLandImg from './drakochi_land.png';

export const LAND_IMAGES: Record<LandId, string> = {
  sol: solSkyImg,
  mu: muSkyImg,
  serj: serjLandImg,
  mona: monaSeaImg,
  duck: duckSeaImg,
  yetti: yettiLandImg,
  roza: rozaLandImg,
  svami: svamiLandImg,
  vulcano: vulcanoLandImg,
  factor: factorLandImg,
  drakochi: drakochiLandImg,
};

export function getMapLandAssetUrls(): string[] {
  return Object.values(LAND_IMAGES);
}
